export const GET_CONSTRUCTION_TYPES = 'GET_CONSTRUCTION_TYPES';
export const GET_CONSTRUCTION_TYPES_SUCCESS = 'GET_CONSTRUCTION_TYPES_SUCCESS';
export const GET_CONSTRUCTION_TYPES_ERROR = 'GET_CONSTRUCTION_TYPES_ERROR';

export const ADD_CONSTRUCTION_TYPE = 'ADD_CONSTRUCTION_TYPE';
export const ADD_CONSTRUCTION_TYPE_SUCCESS = 'ADD_CONSTRUCTION_TYPE_SUCCESS';
export const ADD_CONSTRUCTION_TYPE_ERROR = 'ADD_CONSTRUCTION_TYPE_ERROR';

export const EDIT_CONSTRUCTION_TYPE = 'EDIT_CONSTRUCTION_TYPE';
export const EDIT_CONSTRUCTION_TYPE_SUCCESS = 'EDIT_CONSTRUCTION_TYPE_SUCCESS';
export const EDIT_CONSTRUCTION_TYPE_ERROR = 'EDIT_CONSTRUCTION_TYPE_ERROR';

export const DELETE_CONSTRUCTION_TYPE = 'DELETE_CONSTRUCTION_TYPE';
export const DELETE_CONSTRUCTION_TYPE_SUCCESS = 'DELETE_CONSTRUCTION_TYPE_SUCCESS';
export const DELETE_CONSTRUCTION_TYPE_ERROR = 'DELETE_CONSTRUCTION_TYPE_ERROR';
